import type { AISupportedContextBlocks, Block } from 'shared-types';

type BlockData<T> = Extract<Block, { type: T }>['data'];

interface Params {
  block: Pick<
    Extract<Block, { type: AISupportedContextBlocks }>,
    'draftData' | 'data' | 'type'
  >;
}

const blockHasValidContext = ({ block }: Params) => {
  const { draftData, data, type } = block;

  // filter out empty blocks
  if (type === 'list') {
    const blockData = (draftData || data) as BlockData<'list'>;
    if (!blockData?.listHtml) return false;
  } else {
    // type is either heading, quote or text
    const blockData = (draftData || data) as BlockData<
      'heading' | 'quote' | 'text'
    >;
    if (!blockData?.text) return false;
  }

  return true;
};

export default blockHasValidContext;
